import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    partialBundledLanguages: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "tt_lang",
    },
  });

// Lazily load Arabic bundle + Lateef font only when needed.
const loadedLangs = new Set<string>(["en"]);
export async function ensureLanguage(lng: string) {
  const base = lng.startsWith("ar") ? "ar" : "en";
  if (loadedLangs.has(base)) return;
  loadedLangs.add(base);
  if (base === "ar") {
    const [{ default: ar }] = await Promise.all([
      import("./locales/ar.json"),
      import("@fontsource/lateef/200.css"),
      import("@fontsource/lateef/300.css"),
      import("@fontsource/lateef/400.css"),
    ]);
    i18n.addResourceBundle("ar", "translation", ar, true, true);
  }
}

// Ensure the initially-detected language is available before first paint of
// localized content. Fire-and-forget: components re-render when it resolves.
void ensureLanguage(i18n.language);
i18n.on("languageChanged", (lng) => {
  void ensureLanguage(lng);
});

export default i18n;